/** MUI 调色板配置 — 按V1原型精确颜色 */
import type { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  primary: {
    main: '#1E88E5',
    dark: '#1565C0',
    light: '#E3F2FD',
    contrastText: '#FFFFFF',
    50: '#E3F2FD',
    100: '#BBDEFB',
    200: '#90CAF9',
    300: '#64B5F6',
    400: '#42A5F5',
    500: '#1E88E5',
    600: '#1E88E5',
    700: '#1565C0',
    800: '#1565C0',
    900: '#0D47A1',
  },
  secondary: {
    main: '#43A047',
    light: '#E8F5E9',
    dark: '#2E7D32',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#E53935',
    light: '#FFEBEE',
    dark: '#C62828',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FB8C00',
    light: '#FFF3E0',
    dark: '#E65100',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#43A047',
    light: '#E8F5E9',
    dark: '#2E7D32',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#00d4aa',
    light: '#E0F7F4',
    dark: '#00838F',
    contrastText: '#FFFFFF',
  },
  grey: {
    50: '#F8F9FB',
    100: '#F0F2F5',
    200: '#E8EAED',
    300: '#DADCE0',
    400: '#BDC1C6',
    500: '#9E9E9E',
    600: '#80868B',
    700: '#616161',
    800: '#3C4043',
    900: '#212121',
  },
  background: {
    default: '#F5F7FA',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#212121',
    secondary: '#616161',
    disabled: '#9E9E9E',
  },
  divider: '#E8EAED',
};
